import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import PopupInnerContextComponent from 'webapp/components/popup/inner/context';

export default class TagsPopupEmptyComponent extends PopupInnerContextComponent<PopupData.None> {
	@service('account') declare accountService: Service.Account;

	get showHelpArticle() {
		return !this.accountService.hideDataboxNotWhiteLabeledContentForNonAdmins;
	}
	<template>
		<div class="noTag">
			<CommonUiIconComponent @name="TagFill" @size="md" />
			<p class="tagText">No tags have been assigned yet.</p>
			<br />
			{{#if this.showHelpArticle}}
				<a
					class="tagLink"
					href="https://help.databox.com/overview-tags#databoards"
					target="_blank"
				>
					Learn more about tags
				</a>
			{{/if}}
		</div>
	</template>
}
